module.exports = __webpack_public_path__ + "img/wishlist-1@2x.da53402.webp";